<template>
  <b-card>
    <section v-if="!visit.visitor_did_join && !visit.prisoner_did_join" class="my-1">
      <p class="text-center">
        Unable to produce recording - No participants joined
      </p>
    </section>

    <section v-else>
      <!-- Recording and Audit Log -->
      <div v-if="visit.call_media_visible" class="my-1">
        <!-- Recording status of none and should record as true. Show a button that will generate recording -->
        <div v-if="visit.recording_status === 'none' && visit.should_record">
          <p class="text-center" v-if="showWaiting">
            The recording is now processing. Please come back in 20 minutes to request the access code.
          </p>
          <div v-else>
            <!-- Show generate button. Send request and Toggle showWaiting to true -->
            <b-btn
              variant="success" class="full-width"
              @click="generateRecording()"
            >
              Generate Recording for this Call
            </b-btn>
          </div>
        </div>
        <div v-else-if="visit.recording_status === 'processing'">
          <div v-if="showWaiting">
            <p class="text-center page-header-row">
              The recording is now processing. Please come back in 20 minutes to request the access code.
            </p>
          </div>
          <div v-else>
            <button
              class="btn btn-block btn-success"
              @click="() => showWaiting = true"
            >
              Request Access to Recordings and Audit Log
            </button>
          </div>
        </div>
        <div v-else-if="visit.recording_status === 'ready' || visit.recording_status === 'failed'">
          <!-- Request access -->
          <div v-if="!otpSent">
            <b-btn variant="success" class="full-width" @click="getOTP()">
              Request Access to Recordings and Audit Log
            </b-btn>
          </div>
          <!-- OTP Input -->
          <div v-else-if="otpSent && !otpSupplied">
            <div class="form-group">
              <label>Enter Access Code</label>
              <div class="input-group">
                <input @keydown.enter="submitOTP()" type="text" class="form-control" v-model="otpCode">
                <div class="input-group-append">
                  <button @click="submitOTP()" class="btn btn-success">
                    Submit
                  </button>
                </div>
              </div>
              <small>
                The Access code will have been sent to your email address. If you haven't received the Access code
                click <a href="#" @click="getOTP()">here</a> to have it resent.
              </small>
            </div>
          </div>
          <!-- OTP Supplied -->
          <div v-else>
            <div>
              <p v-if="visit.recording_status === 'failed'">
                Unable to produce recording - This may be because no participants joined the call
              </p>
              <visit-recordings v-else
                                :visit="visit"
                                :otp="otpCode"
              />
            </div>
            <audit-trail
              :visit-id="visit._id"
              :otp="otpCode"
            />
            <purple-scribe
              v-if="purpleScribeEnabled"
              :purple-scribe-status="visit.purple_scribe_status"
              :visit-id="visit._id"
            />
          </div>
        </div>
        <div v-else><p class="text-center">No Recordings available</p></div>
      </div>

      <div v-else>
        <p class="text-center">Recording and Audit Log not available as the video call took place over 30 days ago.</p>
      </div>
    </section>
  </b-card>
</template>

<script>
import PrisonService from '@/services/PrisonService';
import { logger } from '@/util/logger';
import AuditTrail from '@/views/auditTrail/AuditTrail';
import VisitRecordings from '@/views/visitRecordings/VisitRecordings';
import VisitService from '@/services/VisitService';
import PurpleScribe from '@/views/auditTrail/PurpleScribe.vue';

export default {
  props: {
    visit: {
      type: Object,
      required: true,
    },
    purpleScribeEnabled: {
      type: Boolean,
      required: false,
    },
  },
  components: {
    PurpleScribe,
    AuditTrail,
    VisitRecordings,
  },
  data() {
    return {
      showWaiting: false,
      otpCode: null,
      otpSent: false,
      otpSupplied: false,
      otpIssue: false,
    };
  },
  mounted() {
    this.$on('otpIssue', () => {
      if(!this.otpIssue) {
        this.otpIssue = true;
        this.$toast.error('Please check you entered the access code correctly and try again', {
          toastClassName: ['toast-std', 'warning-toast'],
        });
        this.otpCode = null;
        this.otpSupplied = false;
        setTimeout(() => {
          this.otpIssue = false;
        }, 250);
      }
    });
  },
  methods: {
    generateRecording() {
      // Send request
      VisitService.generateRecording(this.visit._id).catch((err) => {
        logger.error('Error generating the recording', err, {visitId: this.visit._id}, 'CS2RecordingAndAuditLog:generateRecording');
      });
      // Set waiting to true
      this.showWaiting = true;
    },
    getOTP() {
      this.$toast.info('Requesting Access...');
      // Request the OTP
      PrisonService.getOTP(this.visit._id).then(res => {
        this.$toast.success('The access code has been sent to your email address', {
          toastClassName: ['toast-std', 'success-toast'],
        });
        // Show input box for otp
        this.otpSent = true;
      }).catch(err => {
        logger.error('Error requesting OTP', err, null, 'CS2RecordingAndAuditLog:getOTP');
        this.$toast.error('There was an error requesting access. Please refresh the page and try again', {
          toastClassName: ['toast-std', 'warning-toast'],
        });
      });
    },
    submitOTP() {
      this.otpSupplied = true;
    },
  },
};
</script>
